import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PageNotFoundComponent } from './core/page-not-found/page-not-found.component';

const appRoutes: Routes = [
  { path: 'eclipse', redirectTo: '/eclipse/user-dashboard', pathMatch: 'full' },
  {
    path: 'portal',
    loadChildren: () => import('./portal/portal.module').then(m => m.PortalModule),
    data: { preload: true }
  },
  {
    path: 'eclipse',
    loadChildren: () => import('./eclipse/eclipse.module').then(m => m.EclipseModule),
    data: { preload: true, breadcrumb: 'Eclipse' }
  },
  {
    path: 'pulse',
    loadChildren: () => import('./pulse/pulse.module').then(m => m.PulseModule),
    data: { preload: true, breadcrumb: 'Pulse' }
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule),
    data: { preload: true }
  },
  {
    path: 'documentation',
    loadChildren: () => import('./documentation/documentation.module').then(m => m.DocumentationModule),
    data: { preload: true }
  },
  { path: '', redirectTo: '/account/login', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      { useHash: true, scrollPositionRestoration: 'enabled', initialNavigation: 'disabled' }
    )
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class AppRoutingModule {
}
